import useApi from '../hook/useApi';

const useRidesApi = () => {
  const { sendRequest, loading, data, error } = useApi();

  const getStates = async (filter) => {
    const queryParams = new URLSearchParams();
    if (filter) queryParams.append('filter', filter.filter);
    if (filter.start_date) queryParams.append('start_date', filter.start_date);
    if (filter.end_date) queryParams.append('end_date', filter.end_date);
    return sendRequest(`/imp/booking_screen/calculated_info_for_bookingscreen?${queryParams.toString()}`, 'GET', {});
  };

  const getRides = async (page = 1, search = "", filters = {}, statusfilter) => {
    const queryParams = new URLSearchParams({ page, search, ...filters });

    if (statusfilter && statusfilter !== 'all') {
      queryParams.append('booking_status', statusfilter);
    }

    return sendRequest(`/imp/booking_screen/get_bookinglist_for_bookingscreen?${queryParams.toString()}`, 'GET', {});
  };


  const rejectRide = async (payload) => {
    return sendRequest(`/imp/booking_screen/booking_close_by_admin`, 'PUT', payload);
  };

  const viewRide = async (id) => {
    return sendRequest(`/imp/booking_screen/get_bookingobject_by_id/${id}`, 'GET', {});
  };

  const getDriverRides = async (user_id, page = 1, limit = 10) => {
    return sendRequest(
      `/imp/booking_screen/get_platformbookings_of_driver?page=${page}&limit=${limit}&user_id=${user_id}`,
      'GET',
      {}
    );
  };

  const getMyRides = async (user_id, page = 1, limit = 10) => {
    return sendRequest(
      `/imp/user_screen/get_my_created_bookings?page=${page}&limit=${limit}&user_id=${user_id}`,
      'GET',
      {}
    );
  };

  const getNearbyDrivers = async (payload) => {
    return sendRequest(
      '/imp/booking_screen/get_driverlist_nearby_pickupdestination',
      'GET',
      payload
    );
  };

  return {
    getStates,
    getRides,
    rejectRide,
    viewRide,
    getDriverRides,
    getMyRides,
    getNearbyDrivers,
    loading,
    data,
    error,
  };
};

export default useRidesApi;